import React, { useState, useEffect, useMemo } from 'react';
import { axios } from 'ApiClient';
import Select from 'react-select';

import {
  Modal,
  ModalBody,
  ModalHeader,
  Col, Row,
  Badge,
  Collapse,
  FormGroup, CustomInput,
  Button, ButtonToolbar,
  Label
} from 'reactstrap';
import Hooks from '@/shared/hooks';

function ViolationChip({ found, ...props }) {
  const color = found === 'Yes' ? 'danger' : 'success';
  const icon = found === 'Yes'
    ? <i className="fa fa-exclamation-triangle mr-1" style={{ fontSize: '0.8em' }} />
    : <i className="fa fa-check-circle mr-1" style={{ fontSize: '0.8em' }} />;
  return <span style={{ marginBottom: '-10px' }}><Badge color={color} {...props} pill style={{ fontSize: '14px', width: '120px' }}>{icon}{found === 'Yes' ? 'Violation' : 'No Violation'}</Badge><div style={{ fontSize: '12px' }} className='text-muted text-center'>Violation?</div></span>;
}

function RiskChip({ risk, hideLabel = false, ...props }) {
  const map = { High: 'danger', Medium: 'warning', Low: 'info', No: 'success' };
  const keyRisk = risk?.replace(' Risk', '');
  const icon = keyRisk === 'High'
    ? <i className="fa fa-exclamation-triangle mr-1" style={{ fontSize: '0.8em' }} />
    : keyRisk === 'Medium'
      ? <i className="fa fa-angle-up mr-1" style={{ fontSize: '0.8em' }} />
      : <i className="fa fa-angle-down mr-1" style={{ fontSize: '0.8em' }} />;
  return <span style={{ marginBottom: '-10px' }}><Badge color={map[keyRisk] || 'secondary'}  style={{ fontSize: '12px',  }} {...props} pill>{icon}{risk}</Badge>{!hideLabel && <div style={{ fontSize: '10px' }} className='text-muted text-center'>Risk</div>}</span>;
}

function ActionChip({ action, ...props }) {
  let color = 'secondary', icon = null;
  if (action?.includes('Reject')) {
    color = 'danger';
    icon = <i className="fa fa-exclamation-triangle mr-1" style={{ fontSize: '0.8em' }} />;
  } else if (action?.includes('Review')) {
    color = 'warning';
    icon = <i className="fa fa-angle-up mr-1" style={{ fontSize: '0.8em' }} />;
  } else if (action?.includes('Approve') || action === 'None') {
    color = 'success';
    icon = <i className="fa fa-check-circle mr-1" style={{ fontSize: '0.8em' }} />;
  }
  return <span style={{ marginBottom: '-10px' }}><Badge color={color} {...props} pill style={{ fontSize: '14px',  }}>{icon}{action}</Badge><div style={{ fontSize: '12px' }} className='text-muted text-center'>Action</div></span>;
}

function getFlagEmoji(language) {
  const map = {
    "French": "🇫🇷",
    "English": "🇺🇸",
    "Spanish": "🇪🇸",
    "German": "🇩🇪",
    "Russian": "💀",
    "Portuguese": "🇵🇹",
    "Italian": "🇮🇹",
    "Arabic": "🇸🇦",
    "Chinese": "🇨🇳",
    "Japanese": "🇯🇵",
    "Korean": "🇰🇷"
  };
  return map[language] || "🏳️";
}


export const modalId = 'trinity-info-modal';

const TrinityResult = () => {
  const { data: dataModal, showModal: isOpen, close: closeF } = Hooks.useModalHook(modalId);
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showViolationsOnly, setShowViolationsOnly] = useState(false);
  const [severityFilter, setSeverityFilter] = useState('');
  const [actionFilter, setActionFilter] = useState('');
  const [openStates, setOpenStates] = useState({});
  const closeFunc = () => {
    setRes(null);
    setLoading(false);
    setShowViolationsOnly(false);
    setSeverityFilter('');
    setActionFilter('');
    setOpenStates({});
    closeF();
  }
  const fetchData = async (prospect) => {
    try {
      setLoading(true);
      const response = await axios.post('/api/brand/deals/post-trinity-result', {
        prospectId: prospect._id || prospect.id,
      });
      const result = response.data;
      setRes(result);
    } catch (error) {
      console.error('Error fetching Trinity result:', error);
      setRes({ error: 'Failed to fetch Trinity result' });
    }
    setLoading(false);
  };
  useEffect(() => {
    if (dataModal?.prospect) {
      const { prospect } = dataModal;
      fetchData(prospect);
      console.log('Prospect data!!!!!!!:', prospect);
    }
  }, [dataModal]);
  const filteredResults = useMemo(() => {
    const message = res?.message || {};
    const d = JSON.parse(message?.content || 'null');
    console.log('filteredResults', d?.results, severityFilter, showViolationsOnly, actionFilter);
    return (d?.results || []).filter(res => {
      if (showViolationsOnly && res.violation_found !== 'Yes') return false;
      if (severityFilter && res.severity_rating !== severityFilter) return false;
      if (actionFilter && res.recommended_action !== actionFilter) return false;
      return true;
    }).sort((a, b) => b.violation_found.localeCompare(a.violation_found));
  }, [showViolationsOnly, severityFilter, actionFilter, res]);

  const filteredBrandResults = useMemo(() => {
    const message = res?.message || {};
    const d = JSON.parse(message?.content || 'null');
    console.log('filteredResults', d?.results, severityFilter, showViolationsOnly, actionFilter);
    return (d?.brand_results || []).map(brand => {
      return {
        ...brand,
        results: brand.results.filter(res => {
          if (showViolationsOnly && res.violation_found !== 'Yes') return false;
          if (severityFilter && res.severity_rating !== severityFilter) return false;
          if (actionFilter && res.recommended_action !== actionFilter) return false;
          return true;
        }).sort((a, b) => b.violation_found.localeCompare(a.violation_found))
      }
    });
  }, [showViolationsOnly, severityFilter, actionFilter, res]);

  const isAllOpened = useMemo(() => {
     const message = res?.message || {};
    const d = JSON.parse(message?.content || 'null');

    return (d?.results || []).every(res => openStates[res.guideline_name]);
  }, [filteredResults, openStates]);

  if (!dataModal?.prospect) return false;
  const message = res?.message || {};
  const data = JSON.parse(message?.content || 'null');
  const creator = res?.creator || {};
  const account = data?.accounts ? data?.accounts.find(a => a.type === 'youtube') : {};
  const results = data?.results || [];
  const sources = data?.sources || [];

  const severityOptions = [
    { value: 'High', label: 'High' },
    { value: 'Medium', label: 'Medium' },
    { value: 'Low', label: 'Low' },
  ];

  const actionOptions = [
    { value: 'Reject', label: 'Reject' },
    { value: 'Approve', label: 'Approve' },
  ];
  console.log('filteredResults', filteredResults);
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => closeFunc()}
      style={{ maxWidth: '800px', width: '100%' }}
    >
      <ModalHeader toggle={() => closeFunc()} tag="h4" className="modal-title-statistics">Trinity Results</ModalHeader>
      <ModalBody className='px-0'>
        <Row>
          {data && data.error ? (<Col xs={12}>
            <div style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '10px' }} className='mb-3'>
              <div >
                <div className="d-flex align-items-center">
                  <div>
                    <strong>Error Title:</strong> {data.title}
                  </div>
                </div>
                <div className=' text-muted mt-2'> {data.message}</div>
              </div>
            </div>
          </Col>) : null}

          {data && data.summary ? (<Col xs={12}>
            <div style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '10px' }} className='mb-3'>
              <div >
                <div className="d-flex align-items-center">
                  <img
                    src={account?.thumbnail}
                    alt="Thumbnail"
                    className="rounded-circle mr-3"
                    width="64"
                    height="64"
                    style={{ maxWidth: '64px', maxHeight: '64px' }}
                  />
                  <div className="flex-fill">
                    <h5 className="mb-1 font-weight-bold">{data?.creatorName}</h5>
                    <small className="text-muted">{data?.title}</small>
                    <div className="mt-1">
                      <RiskChip risk={data?.risk_level} className="mr-2 py-2 px-3" hideLabel  style={{ fontSize: '14px'}}/>
                      <Badge color={data?.acceptance_status === 'Accepted' ? "success" : "danger"} className='px-3 py-2' pill style={{ fontSize: '14px' }}>{data?.acceptance_status}</Badge>
                    </div>
                  </div>
                  <div>
                    <strong>Language:</strong> <Badge pill out className="text-dark px-2 py-2" color="light">{getFlagEmoji(data.language_detected)} {data.language_detected}</Badge>
                  </div>
                </div>
                <div className=' text-muted mt-2'>{data.summary}</div>
                <div className=' text-muted mt-2'><Label className="font-weight-bold">Language Reason:</Label> {data.language_reason}</div>
                <div className=' text-muted mt-2'><Label className="font-weight-bold">Category:</Label> {creator.category}</div>
                <div className=' text-muted mt-2'><Label className="font-weight-bold">Analyzed Videos:</Label>
                  <ul>
                    {sources?.filter(a => a.source_name === 'Youtube Video').map((src, index) => (
                      <li key={index}>
                        {src.source_url ? (
                          <a href={src.source_url} target="_blank" rel="noreferrer">{src.source_title}</a>
                        ) : (
                          <strong>{src.source_title}</strong>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </Col>) : null}
          {data && data.summary ? <Col xs={12}>
            <form className=" mb-3 mt-3 row ">
              <Col>
                <div className="form-row">
                  <div className="col mr-2">
                    <FormGroup className="mb-0">
                      <Select
                        value={severityOptions.find(option => option?.value === severityFilter)}
                        onChange={(option) => setSeverityFilter(option?.value || '')}
                        options={severityOptions}
                        isClearable
                        className="w-100"
                        placeholder="Risk"
                        key={new Date() + severityFilter} // Force re-render on filter change
                      />
                    </FormGroup>
                  </div>
                  <div className="col">
                    <FormGroup className="mb-0">
                      <Select
                        value={actionOptions.find(option => option?.value === actionFilter)}
                        onChange={(option) => setActionFilter(option?.value || '')}
                        options={actionOptions}
                        isClearable
                        className="w-100"
                        placeholder="Action"
                        key={new Date() + actionFilter} // Force re-render on filter change
                      />
                    </FormGroup>
                  </div>
                  <div className="col">
                    <FormGroup className="mt-2">
                      <CustomInput type="checkbox" id="violationOnly" label="Violations Only" checked={showViolationsOnly} onChange={() => setShowViolationsOnly(v => !v)} />
                    </FormGroup>
                  </div>
                </div>
              </Col>
              <Col sm="auto">
                <Button className='mb-0 mr-2' onClick={() => {
                  setShowViolationsOnly(false);
                  setSeverityFilter('');
                  setActionFilter('');
                  setOpenStates({});
                }}>Reset Filters</Button>
                <Button className='mb-0' onClick={() => {
                  results.map(a => a.guideline_name).forEach(name => {
                    setOpenStates(prev => ({ ...prev, [name]: isAllOpened ? false : true }));
                  });
                }}>{isAllOpened ? 'Collapse' : 'Expand'} All</Button>
              </Col>
            </form>
          </Col> : null}
          {data?.brand_results?.length > 0 ? (<Col xs={12}>
            <div className="mb-2 w-100 " key={res.guideline_name} >
              {filteredBrandResults?.map((item, index) => (
                <div key={index} className="d-flex justify-content-between align-items-center">
                  <div className='w-100'>
                    <h4 className='d-flex w-100 mb-2 mt-3 font-weight-bold'>{item.brand_name}  Guideline Summary</h4>
                    {item.results?.map(res => {
                      const isOpen = true;
                      return (
                        <div className="mb-2" key={res.guideline_name} style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '10px' }}>
                          <div>
                            <div className="d-flex align-items-center" onClick={() => setOpenStates(prev => ({ ...prev, [res.guideline_name]: !isOpen }))}>
                              {res.violation_found === 'Yes'
                                ? <i className="fa fa-exclamation-triangle text-danger mr-2" style={{ fontSize: '1em' }} />
                                : <i className="fa fa-check-circle text-success mr-2" style={{ fontSize: '1em' }} />}
                              <h4 className="mr-3 font-weight-bold" style={{ width: '220px' }}>{res.guideline_name}</h4>
                              <ViolationChip found={res.violation_found} className="mr-2 py-2 px-3" />
                              <ActionChip action={res.recommended_action} className="mr-2 py-2 px-3" />
                            </div>
                            <RiskChip risk={res.severity_rating} className="py-1 px-2" hideLabel/>
                            <Collapse isOpen={isOpen}>
                              <hr />
                              {res.notes && <p><strong>Note:</strong> {res.notes}</p>}
                              <ul>
                                {res?.sources?.filter(a => a.source_url)?.map(src => (
                                  <li key={src.source_url}>
                                    <a href={src.source_url} target="_blank" rel="noreferrer">[{src.source_name}] {src.source_title}</a>
                                    <div className="text-muted small">{src.source_summary}</div>
                                  </li>
                                ))}
                                {res?.sources?.filter(a => !a.source_url)?.map(src => (
                                  <li key={src.source_title}>
                                    <strong>{src.source_title}</strong>
                                    <div className="text-muted small">{src.source_summary}</div>
                                  </li>
                                ))}
                              </ul>
                            </Collapse>
                          </div>
                        </div>
                      );
                    })}

                  </div>
                </div>
              )) || null}
            </div></Col>) : null}

          {data && data.summary ? <Col xs="12">
            <h4 className='d-flex w-100 mb-2 mt-3 font-weight-bold'>Common Guideline Summary</h4>
            {filteredResults.map(res => {
              const isOpen = openStates[res.guideline_name] ?? res.violation_found === 'Yes';
              return (
                <div className="mb-2" key={res.guideline_name} style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '10px' }}>
                  <div>
                    <div className="d-flex align-items-center" onClick={() => setOpenStates(prev => ({ ...prev, [res.guideline_name]: !isOpen }))}>
                      {res.violation_found === 'Yes'
                        ? <i className="fa fa-exclamation-triangle text-danger mr-2" style={{ fontSize: '1em' }} />
                        : <i className="fa fa-check-circle text-success mr-2" style={{ fontSize: '1em' }} />}
                      <h4 className="mr-3 font-weight-bold" style={{ width: '220px' }}>{res.guideline_name}</h4>
                      <ViolationChip found={res.violation_found} className="mr-2 py-2 px-3" />

                      <ActionChip action={res.recommended_action} className="mr-2 py-2 px-3" />
                      <div className="ml-auto" key={new Date()}>{isOpen ? <i className="fa fa-angle-up" style={{ fontSize: '1em' }} /> : <i className="fa fa-angle-down" style={{ fontSize: '1em' }} />}</div>
                    </div>
                    <RiskChip risk={res.severity_rating} className="mr-2 py-1 px-2" hideLabel />
                    <Collapse isOpen={isOpen}>
                      <hr />
                      {res.note_translation && <p><strong>Reason:</strong> {res.note_translation}</p>}
                      {res.note_original && <p><strong>Note:</strong> {res.note_original}</p>}
                      {res.translated_notes && <p><strong>Translated Note:</strong> {res.translated_notes}</p>}
                      <ul>
                        {res.sources?.filter(a => a.source_url)?.map(src => (
                          <li key={src.source_url}>
                            <a href={src.source_url} target="_blank" rel="noreferrer">[{src.source_name}] {src.source_title}</a>
                            <div className="text-muted small">{src.source_summary}</div>
                          </li>
                        ))}
                        {res.sources?.filter(a => !a.source_url)?.map(src => (
                          <li key={src.source_title}>
                            <div>{src.source_title}</div>
                            <div className="text-muted small">{src.source_summary}</div>
                          </li>
                        ))}
                      </ul>
                    </Collapse>
                  </div>
                </div>
              );
            })}

            {filteredResults.length === 0 && (
              <div className="text-center text-muted py-4">No guidelines match your filters.</div>
            )}
          </Col> : <Col>
            {!loading && (data && !data?.error) ? dataModal?.prospect?.approvalStatus?.ai?.notes : ''}
          </Col>}
        </Row>
      </ModalBody>
      <ButtonToolbar className="modal__footer">
        <Button className="modal_cancel btn-sm" color="secondary" onClick={() => { closeFunc(); }}>Close</Button>
      </ButtonToolbar>
    </Modal>
  );
}

TrinityResult.propTypes = {
};

export default TrinityResult;
